module.exports = __webpack_public_path__ + "static/media/pullups.ee657e65.jpg";